import { ChartMarker } from "../../structures/models/chart-marker";

export class BarChartModel{
    public title: string;
    public mode:string;
    public data: BarChartTrace[];
    public layout:BarChartLayout;
    constructor (title:string, data: BarChartTrace[], mode:string = null, layout:BarChartLayout = null){
        this.title = title;
        this.mode = mode;
        this.data = data;
        this.layout = layout;
    }
}
export class BarChartTrace {
    public name:string;
    public x:number[];
    public y:number[];
    public orientation: string;
    public type:string;
    public marker:ChartMarker;
}
export class BarChartLayout {
    public title: string;
    public barmode:string;
}